<!-- 由 suu 创建于 2025-03-14 星期五 -->
<template>
  <div class="project-two">
    <img
      class="logo"
      :style="{ marginTop: statusBarHeight + 'px' }"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/1e5c931ea0d78f54dd1679c1922280bb_wh=1029_240.webp"
      alt=""
    />
    <div class="card-container">
      <div class="circle"></div>
      <img
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/6a9eb0cc0d314b5ab8c19cc1a4de92f9_wh=177_150.webp"
        class="card-bg-image"
        alt=""
      />
      <img
        class="project-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/c4bb4401cdbd47415374f5dac0562b14_wh=201_42.webp"
        alt=""
      />
      <img
        class="pen-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/a809aa1b8d96b62bef185fc1c78d672e_wh=201_237.webp"
        alt=""
      />
      <div class="user-info">
        <img class="avatar" :src="info.image" alt="" />
        <div class="truename">{{ info.truename || '未知' }}</div>
      </div>
      <div class="user-bottom" v-if="info.state == 3">
        <div class="target-desc"
          >教练已接受你的<span class="target-text">{{ goalText }}</span
          >挑战！<br />去健萌APP查看挑战进度吧～</div
        >
      </div>
      <div class="user-bottom" v-else>
        <div class="target-desc">
          <div v-if="info.e_type"
            >教练已接受你的<span class="target-text">{{ goalText }}</span
            >挑战！<br />挑战将于{{
              info.act_start_tiem | filterCoachEndTime
            }}正式开始～</div
          >
          <div v-else
            >您已确认<span class="target-text">{{ goalText }}</span
            >的挑战目标！<br />正在发起和主教练的对赌挑战</div
          >
        </div>
        <div class="tips-content" v-if="!info.e_type">
          教练将于<span class="pink"
            >{{ info.e_coach_tiem | filterCoachEndTime }}24:00前</span
          >主动联系您确认<br />对赌目标，线下签署Project挑战书。
        </div>
      </div>
      <div class="timeout-container" v-if="info.state == 2">
        <div class="t-title">挑战开始倒计时</div>
        <van-count-down
          class="my-count-down"
          :time="time"
          format="DD:HH:mm:ss"
          @finish="bindFinish"
        >
          <template #default="timeData">
            <div class="time-container">
              <div class="time-item">{{ timeData.days | filterTimeLeft }}</div>
              <div class="time-item">{{ timeData.days | filterTimeRight }}</div>
              <div class="time-unit">天</div>
              <div class="time-item">{{ timeData.hours | filterTimeLeft }}</div>
              <div class="time-item">{{
                timeData.hours | filterTimeRight
              }}</div>
              <div class="time-unit">时</div>
              <div class="time-item">{{
                timeData.minutes | filterTimeLeft
              }}</div>
              <div class="time-item">{{
                timeData.minutes | filterTimeRight
              }}</div>
              <div class="time-unit">分</div>
            </div>
            <!--   <span class="block">{{ timeData.seconds }}</span> -->
          </template>
        </van-count-down>
      </div>
    </div>
    <img
      class="go-app-image"
      v-if="!isApp"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/8b6ee590d2ade862055fc894e81c1850_wh=981_444.webp"
      alt=""
    />
    <div class="jump-app-btn" @click="bindClick">
      <span>{{ isApp ? '去约课' : '去健萌APP' }}</span>
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
    </div>
  </div>
</template>

<script>
import { goalData } from '../data.js'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  name: 'project-two',

  components: { WxOpenLaunchApp },

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      statusBarHeight: 35,
      time: 0,
      extinfo: '',
      goalData: goalData
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    },
    goalText() {
      //优先取教练填写的目标类型 ，没有则取会员报名的目标类型
      return (
        this.goalData.find(
          (item) => item.id === (this.info.e_type || this.info.u_type)
        )?.text || ''
      )
    }
  },
  filters: {
    filterTimeLeft(num) {
      return Math.floor(num / 10)
    },
    filterTimeRight(num) {
      return num % 10
    },
    filterCoachEndTime(dateStr) {
      if (!dateStr) {
        return ''
      }
      const date = new Date(dateStr.replace(/-/g, '/'))
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${month}月${day}日`
    }
  },
  watch: {},

  created() {
    this.getStatusBarHeight()
    this.time = this.computedTime(
      this.info.act_start_tiem,
      this.info.server_time
    )
    this.extinfo =
      '/web?url=' +
      encodeURIComponent(`${location.origin}${location.pathname}`) +
      '&isJM=1&isAddToken=false'
  },

  mounted() {
    this.$http.get('member/index?a=shareLogPush', {
      from: `project活动-报名成功页曝光-${this.$route.query.tfrom || ''}`,
      from_id: 250319
    })
  },

  destroyed() {},

  methods: {
    async getStatusBarHeight() {
      let res = await this.$betterwe.getAppBarHeight()
      if (res) {
        this.statusBarHeight = res.statusBarHeight
          ? res.statusBarHeight + 67
          : 35
      }
    },
    computedTime(dayStr, serverTime) {
      if (!dayStr || !serverTime) {
        return 0
      }
      dayStr = dayStr.replace(/-/g, '/')
      const targetDate = new Date(dayStr)
      const currentDate = new Date(serverTime.replace(/-/g, '/'))
      const timeDiff = targetDate.getTime() - currentDate.getTime()
      if (timeDiff < 0) {
        return 0
      }
      return Math.floor(timeDiff)
    },
    /* 倒计时结束 */
    bindFinish() {
      this.$emit('finish')
    },
    bindClick() {
      if (this.isApp) {
        //去约课
        this.$betterwe.jumpRoute('/jMAppointment?isLogin=1')
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-去约课按钮点击（APP）-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250319
        })
      } else {
        this.$http.get('member/index?a=shareLogPush', {
          from: `project活动-去健萌APP按钮点击（H5）-${
            this.$route.query.tfrom || ''
          }`,
          from_id: 250319
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-two {
  box-sizing: border-box;
  min-height: 100vh;
  background: #ff3b86;
  position: relative;
  overflow: hidden;
  padding-bottom: 100px;
  .logo {
    margin: 40px auto 0px;
    width: 343px;
    height: 80px;
  }
  .card-container {
    position: relative;
    width: 343px;
    box-sizing: border-box;
    margin: 42px auto 20px;
    background: #ffffff;
    border-radius: 10px;
    padding: 32px 16px 30px;

    .circle {
      position: absolute;
      left: 50%;
      top: 13px;
      transform: translate(-50%, 0%);
      width: 85px;
      height: 12px;
      background: #ff3b86;
      border-radius: 6px;
    }

    .card-bg-image {
      position: absolute;
      left: 173px;
      top: -23px;
      width: 54px;
    }

    .project-image {
      position: absolute;
      width: 67px;
      right: 10px;
      top: 10px;
    }

    .pen-image {
      position: absolute;
      width: 67px;
      top: 105px;
      right: -16px;
    }

    .user-info {
      display: flex;
      align-items: flex-end;
      margin-bottom: 13px;

      .avatar {
        width: 28px;
        height: 28px;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
        margin-right: 10px;
      }

      .truename {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
      }
    }

    .user-bottom {
      padding-bottom: 24px;

      .target-desc {
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        line-height: 30px;

        .target-text {
          margin: 0px 2px;
          color: rgba(234, 57, 129, 1);
          text-decoration: underline;
        }
      }

      .tips-content {
        margin-top: 10px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.7);
        line-height: 18px;

        .pink {
          color: rgba(234, 57, 129, 1);
        }
      }
    }

    .timeout-container {
      border-top: 0.5px dashed rgba(234, 57, 129, 0.7);
      padding: 23px 10px 0px;
      text-align: center;

      .t-title {
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 26px;
        color: #ea3981;
        line-height: 23px;
        margin-bottom: 19px;
      }

      .my-count-down {
        .time-container {
          display: flex;
          align-items: center;
          justify-content: center;

          .time-item {
            position: relative;
            width: 30px;
            height: 39px;
            background: #ea3981;
            border-radius: 2px;
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 31px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0px 1.5px;
          }

          .time-item::after {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0%, -50%);
            width: 100%;
            background-color: #fff;
            height: 1px;
          }

          .time-unit {
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 16px;
            color: #ea3981;
            line-height: 22px;
            margin: 0px 7px;
          }
        }
      }
    }
  }

  .go-app-image {
    margin: 0 auto;
    width: 327px;
  }

  .jump-app-btn {
    position: fixed;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%, 0%);
    width: 343px;
    height: 50px;
    box-sizing: border-box;
    border: 2px solid #fff;
    border-radius: 2px;
    background: rgba(17, 204, 102, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    border-radius: 25px;
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.26);
  }
}
</style>
